import { UseMutationOptions, useMutation } from "@tanstack/react-query"
import { AxiosError } from "axios"

import {
  DeleteProductionSiteFieldDefinitionParams,
  DeleteProductionSiteFieldDefinitionQuery,
} from "@tfg/types/schemas/modules/traceability/queries/delete-production-site-field-definition.dto"

import { httpClient } from "~/backend/axios"
import { queryClient } from "~/backend/queryClient"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

export const useDeleteProductionSiteFieldDefinitionMutation = (
  options?: UseMutationOptions<
    unknown,
    AxiosError,
    DeleteProductionSiteFieldDefinitionParams
  >
) =>
  useMutation({
    mutationFn: async ({
      id,
      organizationId,
    }: DeleteProductionSiteFieldDefinitionParams &
      DeleteProductionSiteFieldDefinitionQuery) => {
      return await httpClient.delete(
        `/admin/traceability/delete-production-site-field-definition/${id}`,
        {
          params: { organizationId },
        }
      )
    },
    onSuccess: (data, variables, onMutateResult, context) => {
      options?.onSuccess?.(data, variables, onMutateResult, context)
      queryClient.invalidateQueries({
        queryKey: ["prodSiteFieldDefs", variables.organizationId],
      })
      showSuccessNotification({
        title: "Success",
        message: "Production field definition deleted",
      })
    },
    onError: (error: AxiosError) => {
      showAxiosError({
        notificationTitle: "Error",
        notificationMessage: error.message,
        showNotification: true,
        error,
      })
    },
  })
